
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/properties/[type]",
      function () {
        return require("private-next-pages/properties/[type]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/properties/[type]"])
      });
    }
  